export default __webpack_public_path__ + "static/media/desktop.32a54ffd.png";